import React, { useState, useEffect, useMemo } from "react";
import profileImg1 from "assets/images/adam.jpg";
import profileImg2 from "assets/images/sam.jpg";
import profileImg3 from "assets/images/chris.jpg";
import Rating from "assets/images/rating.svg";
import "./index.scss";

export default function FeeBreakdown({ afsData }) {
  const {
    bonus = 0,
    flatfee = 0,
    installmentFee = 0.0,
    courtFee = 0.0,
  } = afsData || {};

  const totalflatfee = flatfee + installmentFee;

  const installmentPayments = useMemo(() => {
    return [
      `$${flatfee.toFixed(2)}`,
      `$${(flatfee / 2 + installmentFee).toFixed(2)}`,
      `$${(flatfee / 3 + installmentFee).toFixed(2)}`,
    ];
  }, [flatfee, installmentFee]);

  const [selectedInstallment, setSelectedInstallment] = useState("");

  useEffect(() => {
    if (installmentPayments.length && !selectedInstallment) {
      setSelectedInstallment(installmentPayments[0]);
    }
  }, [installmentPayments, selectedInstallment]);

  const savingsBonus = `${bonus.toFixed(0)}%`;

  const attorneys = [
    {
      name: "Adam C. Fullman",
      title: "Attorney/Founding Partner",
      img: profileImg1,
      rating: Rating,
    },
    {
      name: "Sam Dehbozorgi",
      title: "Attorney/Partner",
      img: profileImg2,
      rating: Rating,
    },
    {
      name: "Christopher J. Peters",
      title: "Attorney/Partner",
      img: profileImg3,
      rating: Rating,
    },
  ];

  return (
    <div className="fee-breakdown">
      {/* Attorneys */}
      <div className="fee-breakdown__attorneys">
        {attorneys.map((attorney, i) => (
          <div className="fee-breakdown__attorney" key={i}>
            <img
              src={attorney.img}
              alt={attorney.name}
              className="fee-breakdown__photo"
            />
            <div className="fee-breakdown__attorney_info">
              <div className="fee-breakdown__name">{attorney.name}</div>
              <div className="fee-breakdown__title">{attorney.title}</div>
              <img
                src={attorney.rating}
                alt={attorney.name}
                className="fee-breakdown__rating"
              />
            </div>
          </div>
        ))}
      </div>

      <div className="fee-breakdown__section">
        {/* Fee Table */}
        <div className="fee-breakdown__table">
          <div className="fee-breakdown__cell">
            <div
              className="fee-breakdown__label"
              style={{ paddingTop: "1.6rem" }}
            >
              Flat Fee
            </div>
            <div className="fee-breakdown__value">
              ${totalflatfee.toFixed(0)}
            </div>
            <div className="fee-breakdown__subtext">
              {courtFee !== 0 && `+ Court fees of $${courtFee}`}
            </div>
          </div>
          <div className="fee-breakdown__cell fee-breakdown__cell--right">
            <div className="fee-breakdown__label">
              Savings Bonus
              <sup>
                {" "}
                <strong>*</strong>
              </sup>
            </div>
            <div className="fee-breakdown__value">{savingsBonus}</div>
            <div className="fee-breakdown__subtext">
              of whatever we save you.
            </div>
          </div>
        </div>

        <p className="fee-breakdown__disclaimer">
          <strong>*</strong> Savings Bonus is in addition to the flat fee. It is
          based on the difference between the amount of debt claimed by the
          creditor and the settlement amount..
        </p>
      </div>
    </div>
  );
}
